import React from "react";

const Headline = (props) => {
    return (
        <div className="position-relative mb-5" style={props.style}>
            <h1 className="text-info">{props.title}</h1>
            <h2 className="text-info" style={{fontSize: "1.2rem", fontWeight: "normal"}}>{props.subtitle}</h2>  
        </div>
    );
};

export default Headline;